import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Modal, Button} from 'react-bootstrap';
import Select from 'react-select';
import { Checkbox } from 'react-bootstrap';
import RndModal from '../../../components/modals/RndModal';
import WorkOrderSearchComponent from './WorkOrderSearch';

const EmailTagsModal = ({ email, tagsFilterList, onClose, onSelectAssignee, onSelectTag, isLoading, workOrderList, onSearchWorkOrderList, currentEmailData }) => {
  const [selectWoMode, setSelectWoMode] = useState(false);

  if (!email) {
    return null;
  }

  const currentCategories = (email.msg_tags && email.msg_tags.split(',')) || [];
  const hasCategory = cat => currentCategories.some(catName => catName.toLowerCase() === cat.CategoryName.toLowerCase());

  const assigneeOptionList = (tagsFilterList.csUsers || []).map(u => ({value: u.value, label: u.name}));

  const fdCategories = tagsFilterList.categories || [];
  const isWoNumCategory = t => /^WO\d+$/i.test(t);
  const woNumCategories = currentCategories.filter(isWoNumCategory);
  const selFdCsUserCategory = fdCategories.find(c => c.IsCsUser && hasCategory(c)) || fdCategories.find(c => c.IsCsUserTODO && hasCategory(c));
  const selCsUser = selFdCsUserCategory && assigneeOptionList.find(u => u.value === selFdCsUserCategory.CSUserID);

  const handleSelectAssignee = ({value}) => {
    onSelectAssignee(value);
  };

  const handleSelectTag = (catItem, checked) => {
    if (catItem.IsSelectWO) {
      setSelectWoMode(true);
      return;
    }

    onSelectTag(catItem.CategoryName, checked);
  };

  const handleShowSelectWoView = (show) => {
    setSelectWoMode(show);
  };

  const assigneeSelect = (
    <div className="tags-overlay-content-input">
      <span>Assignee:</span>
      <Select
        value={selCsUser}
        options={assigneeOptionList}
        onChange={handleSelectAssignee}
        clearable={false}
      />
    </div>
  );

  const handleSelectWo = (wo) => {
    onSelectTag(wo.woMemfisId, true);
    setSelectWoMode(false);
  };

  const renderEditTagsView = () => {
    return (
      <>
        {email.asset_url && (
          <div className="tags-overlay-content-input">
            <a href={email.asset_url} target="_blank" rel="noopener noreferrer">Navigate to the asset</a>
          </div>
        )}
        {assigneeSelect}
        {fdCategories.map((catItem, catIdx) => {
          const allowRenderCategory = catItem.CategoryName === 'Unknown WO' || catItem.CategoryName === 'WO Irrelevant' || catItem.IsSelectWO === 1;
          if (!allowRenderCategory) {
            return null;
          }

          return (
            <React.Fragment key={`cat-${catIdx}`}>
              {catItem.IsSelectWO ?
                woNumCategories.map(woNum => (
                  <Checkbox
                    key={`cat-${catIdx}-${woNum}`}
                    checked={true}
                    onChange={() => onSelectTag(woNum, false)}
                    disabled={isLoading}
                  ><span style={{color: catItem.Color}}>{woNum}</span></Checkbox>
                )) : null
              }
              <Checkbox
                checked={currentCategories.includes(catItem.CategoryName)}
                onChange={(event) => handleSelectTag(catItem, event.target.checked)}
                disabled={isLoading}
              ><span style={{color: catItem.Color}}>{catItem.IsSelectWO ? 'WO#######' : catItem.CategoryName}</span></Checkbox>
            </React.Fragment>
          )
        })}
      </>
    );
  };

  const macrosMatchResultObj = currentEmailData && currentEmailData.macrosMatchResult;
  /*const macrosMatchResultObj = {
    TITLE: currentEmailData?.email?.ShowTitle || email.ShowTitle,
    SHOW_CODE: currentEmailData?.email?.ShowCode || email.ShowCode,
    EPISODE_NUM: currentEmailData?.email?.EpisodeNum || email.EpisodeNum,
  }*/

  const isLoadingEmailData = !currentEmailData;

  return (
    <RndModal
      show={true}
      onHide={onClose}
      backdrop="static"
      enforceFocus={false}
      bsSize="large"
    >
      <Modal.Header closeButton>
        <Modal.Title>Email tags</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div style={{ paddingBottom: '10px', borderBottom: '1px solid #eeeeee' }}>
            <strong>From:</strong> {email.msg_from}<br />
            <strong>To:</strong> {email.msg_to}<br />
            <strong>Subject:</strong> {email.msg_subject}<br />
            <strong>Date:</strong> {moment(email.msg_date).format('MM/DD/YYYY hh:mm:ss A')}<br />
            <strong>Id:</strong> {email.msg_id}
          </div>
          <div className="tags-overlay-content" style={{ marginTop: '5px' }}>
            {isLoadingEmailData ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ marginBottom: '10px' }}>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: '24px', color: '#007bff' }}></i>
                </div>
                <div style={{ color: '#666', fontStyle: 'italic' }}>
                  Loading email data...
                </div>
              </div>
            ) : selectWoMode ? (
              <WorkOrderSearchComponent
                workOrderList={workOrderList}
                onSelectWo={handleSelectWo}
                isLoading={isLoading}
                onClose={() => handleShowSelectWoView(false)}
                onSearchWorkOrderList={onSearchWorkOrderList}
                macrosMatchResult={macrosMatchResultObj}
                macrosProperties={tagsFilterList.macrosProperties || {}}
                currentEmailData={currentEmailData}
              />
            ) : (
              renderEditTagsView()
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="default" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </RndModal>
  );
};

EmailTagsModal.propTypes = {
  email: PropTypes.shape({
    msg_from: PropTypes.string,
    msg_to: PropTypes.string,
    msg_subject: PropTypes.string,
    msg_date: PropTypes.string,
    msg_id: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onSearchWorkOrderList: PropTypes.func.isRequired,
  currentEmailData: PropTypes.object,
};

EmailTagsModal.defaultProps = {
  email: null,
  workOrderList: [],
};

export default EmailTagsModal;